import { render } from "./ClassroomList.vue?vue&type=template&id=7794811f&scoped=true"
import script from "./ClassroomList.vue?vue&type=script&lang=js"
export * from "./ClassroomList.vue?vue&type=script&lang=js"

import "./ClassroomList.vue?vue&type=style&index=0&id=7794811f&scoped=true&lang=css"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7794811f"]])

export default __exports__